export default function ToString(str = '') {
  return String(str);
}
